import { postUpdateStatus } from '../api/postUpdateStatus';
import { setGetViewGameFreespin } from './setGetViewGameFreespin';

const setPostUpdateStatus = (params) => {
    return async (dispatch, getState) => {
        try {
            await postUpdateStatus(params);
            alert('статус обновлен')
            dispatch(setGetViewGameFreespin({
                id: params.id
            }))
        } catch(error) {
            alert('Ошибка обновления')
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostUpdateStatus
}